var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgEquaLogo44X44 = function SvgEquaLogo44X44(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22c0 12.15 9.85 22 22 22 12.145-.013 21.987-9.855 22-22C44 9.85 34.15 0 22 0S0 9.85 0 22zm3.626-.007C3.622 11.84 11.847 3.605 22 3.595v.017c10.158 0 18.397 8.23 18.408 18.388-.008 10.153-8.241 18.38-18.394 18.377-10.153-.002-18.384-8.23-18.388-18.384z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.07 12.1c0 2.264-1.829 4.1-4.092 4.11H18.281a3.561 3.561 0 00-3.554 3.544.267.267 0 01-.267.263.264.264 0 01-.264-.263v-3.828c0-2.27 1.84-4.11 4.11-4.11h14.5a.264.264 0 01.264.285z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.756 19.021H18.28c-2.262 0-4.1 1.83-4.109 4.092v3.828c0 .146.118.264.264.264a.267.267 0 00.267-.264 3.56 3.56 0 013.561-3.561h7.667c2.262 0 4.1-1.83 4.109-4.092a.267.267 0 00-.284-.267z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.712 26.208h-8.43a4.109 4.109 0 00-4.11 4.11v3.807a.264.264 0 00.264.267c.148 0 .267-.12.267-.267a3.561 3.561 0 013.561-3.558h4.62c2.269 0 4.108-1.84 4.108-4.109a.267.267 0 00-.28-.25z",
    fill: "#fff"
  })));
};

export default SvgEquaLogo44X44;